module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" N° de Solicitud: " + _vm._s(_vm.tramite.id) + "\n      "), _c('div', {
    staticClass: "tramite-estado"
  }, [_c('v-chip', {
    attrs: {
      "label": "",
      "color": _vm.estados[_vm.tramite.estado],
      "text-color": "white"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.tramite.estado ? _vm.tramite.estado.replace(/_/gi, ' ') : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "demofi-container"
  }, [(_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('demofi', {
    attrs: {
      "solicitud": _vm.tramite,
      "on-success": _vm.cambiarEstado
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tramite.id_archivo == 1) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "red",
      "icon": "error",
      "value": true
    }
  }, [_vm._v("\n              No existe documento para firmar\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.tramite) ? _c('detalle-doc', {
    attrs: {
      "solicitud": _vm.tramite,
      "pagos": _vm.pagos
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-tooltip', {
    staticClass: "margin-0",
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalles = !_vm.detalles
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.detalles ? 'chevron_left' : 'chevron_right'))]), _vm._v("\n                " + _vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + "\n              ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + " detalles")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo > 1 && this.$store.state.user.id_rol === 7),
      expression: "tramite.id_archivo > 1 && this.$store.state.user.id_rol === 7"
    }],
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cambiarDoc()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("swap_horiz")]), _vm._v("\n                Cambiar\n              ")], 1), _vm._v(" "), _c('span', [_vm._v("Cambiar por otro documento")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo == 1 && _vm.$store.state.archivo > 1 && this.$store.state.user.id_rol === 7),
      expression: "tramite.id_archivo == 1 && $store.state.archivo > 1 && this.$store.state.user.id_rol === 7"
    }],
    staticClass: "margin-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelarCambio()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v("\n              Cancelar cambio\n            ")], 1), _vm._v(" "), (_vm.$store.state.permissions['tramitesDoc:update']) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openObservar(_vm.solicitud)
      }
    }
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.$t('common.observation')) + "\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['firmas:create'] && _vm.pdf !== null && _vm.pdfValido === true) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.$store.state.loading
    },
    on: {
      "click": function($event) {
        return _vm.firm(_vm.solicitud)
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.approve')) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 || _vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 7) ? _c('div', [(_vm.tramite.id_archivo == 1) ? _c('file-upload', {
    attrs: {
      "url": _vm.url,
      "max-filesize": _vm.$store.state.maxFilesize,
      "label": "Arrastre aquí el documento o haga clic aquí para adjuntar el documento PDF para apostillar"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) && _vm.solicitud.firmante) ? _c('v-layout', {
    staticClass: "firma-detalle",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos del usuario")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_nombre_completo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_cargo || '[no registrado]') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Entidad:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.entidad_nombre)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Departamento: ")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_departamento)), _c('br')]), _vm._v(" "), (_vm.solicitud.firmante.certicado_token && _vm.pdf !== null) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firma en documento")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunSubject) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Certificado por:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunIssuer) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha inicio validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.inicioValidez) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha fin validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.finValidez) + " "), _c('br')]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pdfValido === false && _vm.tramite.id_archivo > 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              El documento PDF, no es válido o se encuentra corrupto.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('pdf-view', {
    attrs: {
      "data": _vm.pdf,
      "url": _vm.urlPdf,
      "valido": _vm.validarPdf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tramite.id_archivo == 1 || !_vm.pdf) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              No se adjuntó ningún documento PDF\n            ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    model: {
      value: (_vm.$store.state.modal5),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal5", $$v)
      },
      expression: "$store.state.modal5"
    }
  }, [(_vm.solicitud) ? _c('observar', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d424fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/Firmante.vue
// module id = 502
// module chunks = 2